module.exports = __webpack_public_path__ + "static/img/小龙虾.959e27a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/小龙虾.png
// module id = QUur
// module chunks = 2